module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0003d379a621d85693a57795339255cd.png";